<!-- 编排对阵 -->
<template>
   <div class="">
    <div class="">
        <div class="round-buttons">
            <el-button 
                v-for="round in totalRounds" 
                :key="round"
                :type="currentRound === round ? 'primary' : ''"
                @click="switchRound(round)"
                class="round-btn"
            >
                第{{ round }}轮
            </el-button>
            <el-button type="primary" @click="handleArrangeAll"
                 class="mg-l-10" v-if="roundsData.length === 0"
                 >编排</el-button>              
             <el-button type="danger" @click="toggleFullScreen"
                 class="mg-l-10" 
                 >大屏</el-button>
            <el-button type="warning" @click="handleClearArrange" 
                class="mg-l-10" >清除编排</el-button>
             <el-button type="success" @click="handleOpen"
                    class="mg-l-10" 
                    >设置级牌</el-button> 
            <div style="line-height: 40px;">本轮级牌</div>
            <el-row>           
                <el-col>
                    <el-select v-model="comeRule" 
                        @change="selectPoker"
                        :disabled="disabled">
                        <el-option v-for="item in comeRuleList" 
                        :key="item.value"
                        :label="item.label" 
                        :value="item.value"  >{{ item.label }}
                        </el-option>
                    </el-select>
                </el-col>  
            </el-row>  
            <el-button type="success" icon="el-icon-refresh" @click="editTable" v-if="!isShowEdit">人工调整</el-button>             
        </div>  
        <div class="tips">
            [清除编排]：将清空所有轮次的编排与成绩，操作需谨慎！非必要情况下，优先使用人工调整            
        </div>   
        <div class="tips" v-if="isShowEdit"> 
            [人工调整规则]：主队与主队调整， 客队与客队调整；单数轮调整时，下一轮自动调整；双数轮调整时，只有当前轮调整。
        </div>          
        <div class="tips" v-if="isShowEdit" >
            <span class="tips">请点击要调整的队伍名</span>  
            <el-input v-model="teamname1"  readonly
                placeholder="队伍名" class="player-input"></el-input>
            <el-input v-model="teamname2"  readonly
                placeholder="队伍名" class="player-input"></el-input>            
            <el-button type="danger" @click="saveTeam" class="save-btn">确认调整</el-button>  
            <el-button type="success" @click="backNext">返回</el-button>     
        </div>     
        <!-- <div class="action-buttons" >    
            <el-button type="success" @click="backNext"  v-if="isShowEdit">返回</el-button>        
            <el-button type="success" icon="el-icon-refresh" @click="editTable">人工调整</el-button>
            <el-button type="warning" icon="el-icon-printer" @click="printSchedule">打印赛程</el-button>
            <el-button type="info" icon="el-icon-download" @click="exportData">导出数据</el-button>
        </div> -->
        </div>
        <div><span class="red size18">{{ errorMsg }}</span></div>
        <div class="matches-container">
            <el-card 
                v-for="item in roundsData" 
                :key="item.id"
                class="teamname2"
                :class="slectDeskNo === item.deskNo && isShowEdit ? 'match-card-bg':''"
                shadow="hover"                
            >
                <div class="table-number">{{ item.deskNo }}号桌</div>
                <div class="team team-east" @click="slectTeam(item.deskNo,item.companyWE)">
                    <span class="team-position">东西</span>
                    <div class="team-info">
                        <span class="team-code">{{item.usernameWE}}</span>
                        <span class="team-name">{{ item.companyWE }}</span>
                    </div>
                    <span class="team-role">{{ item.teamTypeWE }}</span>
                </div>
                <div class="team team-south" @click="slectTeam(item.deskNo,item.companySN)">
                    <span class="team-position">南北</span>
                    <div class="team-info">
                        <span class="team-code">{{ item.usernameSN}}</span>
                        <span class="team-name">{{ item.companySN}}</span>
                    </div>
                    <span class="team-role">{{ item.teamTypeSN}}</span>
                </div>
            </el-card>
        </div>
        
        <!-- <el-card class="teams-info">
            <div slot="header" class="teams-title">
                <span>队伍列表</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="showAllTeams = !showAllTeams">
                    {{ showAllTeams ? '收起' : '展开' }}
                </el-button>
            </div>
            <div v-show="showAllTeams" class="teams-grid">
                <div v-for="teamCode in teamCodes" :key="teamCode" class="team-item">
                    <div>{{ teamCode }}</div>
                    <div style="font-size: 0.9rem; color: #666; margin-top: 5px;">{{ teamNames[teamCode] }}</div>
                </div>
            </div>
        </el-card> -->
   </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'

export default {
    props:{
        pubId: {
            type: String,
            default: ''
        },
        pubType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            comeRule: '',
            level: null,
            comeRuleList: [],
            currentRound: 1,
            totalRounds: 4,
            countdown: '60:00',
            showAllTeams: true,
            timer: null,
            disabled:true,
            errorMsg: '',
            isReady: false,
            remainingTime: 60 * 60, // 60分钟倒计时
            isShowEdit: false,
            // 比赛编排数据
            roundsData: {                
            },            
            // 战队名称映射
            teamNames: {
                "A1": "青龙队",
                "A2": "青龙队",
                "B1": "白虎队",
                "B2": "白虎队",
                "C1": "朱雀队",
                "C2": "朱雀队",
                "D1": "玄武队",
                "D2": "玄武队",
                "E1": "麒麟队",
                "E2": "麒麟队",
                "F1": "凤凰队",
                "F2": "凤凰队",
                "G1": "腾蛇队",
                "G2": "腾蛇队",
                "H1": "勾陈队",
                "H2": "勾陈队"
            },            
            // 队伍代码列表
            teamCodes: [
                "A1", "A2", "B1", "B2", 
                "C1", "C2", "D1", "D2", 
                "E1", "E2", "F1", "F2", 
                "G1", "G2", "H1", "H2"
            ],
            round: '',
            teamname1: '',
            teamname2: '',
            slectDeskNo: '',
            clickCount: 1,
        }
    },
    
    created() {

    },
    mounted() {
        this.disabled = true
    },
    computed: {
        // currentMatches() {
        //     return this.roundsData[this.currentRound] || [];
        // }
    },
    methods: {
        ...mapMutations(['SET_ROUND']),
        // 查询轮数
        getNewRound(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.pubId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            round:  item['比赛轮数'] + 1,
                            maxRound: item['轮数']
                        }
                    })
                    // console.log(list)
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    this.SET_ROUND(this.round)
                    this.currentRound = this.round
                    this.totalRounds = list[0].maxRound
                    if(this.round){
                        this.initData()  
                        this.getComeRuleList()
                    }
                    this.getPokerQuery() 
                }
            })
        }, 
        // 赛事编排对阵查询
        initData(){
            let params = {
                opcode: this.$code.PubArrange,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {                    
                    let result = res.Data.DataTable                   
                    if(result.length > 0){ 
                        let arr  = result.map(item=>{
                            let username = `${item['选手名称']}/${item['搭档名称']}`
                            return{
                                deskNo: item['桌号'],
                                id: item['选手编号'],
                                username: username,
                                phone: item['选手手机号'],
                                company: item['协会（俱乐部）'],
                                userId: item['选手账号'],
                                seat: item['座位'],
                                status: item['状态'],
                                matchStatus: item['参赛状态'],
                                teamType: item['主客队']
                            }
                        }) 
                        let statusErr = arr.filter(i=>i.status === '未编排')
                        let statusErr2 = arr.filter(i=>i.status === '已编排')
                        if(statusErr.length > 0 ){
                            this.errorMsg = '未编排，请先点击编排按钮！'                           
                        }else{
                            this.errorMsg = ''
                        }
                        if(statusErr2.length > 0){
                            let newArr = this.selectDeskNo(arr)                           
                            this.roundsData = newArr
                            this.isReady = true
                        }else{
                            this.roundsData = []
                            this.isReady = false
                        }
                       
                    }else{
                        this.roundsData = []                       
                    }
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        selectDeskNo(arr){
            let result = []
            arr.forEach(item => {
                if(!result.some(i => i.deskNo === item.deskNo)){
                    let newArr = arr.filter(user => user.deskNo === item.deskNo)
                    let seatWE = (newArr.filter(i =>  i.seat.includes('东')))[0].seat
                    let seatSN = (newArr.filter(i =>  i.seat.includes('北')))[0].seat
                    let usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username 
                    let usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username  

                    let teamTypeWE = (newArr.filter(i =>  i.seat.includes('东')))[0].teamType
                    let teamTypeSN = (newArr.filter(i =>  i.seat.includes('北')))[0].teamType
                    
                    let companyA = (newArr.filter(i =>  i.seat.includes('东')))[0].company
                    let companyB = (newArr.filter(i =>  i.seat.includes('北')))[0].company
                    result.push({
                        deskNo: item.deskNo,
                        seatWE: seatWE,
                        seatSN: seatSN,
                        teamTypeWE: teamTypeWE,
                        teamTypeSN: teamTypeSN,
                        usernameWE: usernameWE,
                        usernameSN: usernameSN, 
                        status: item.status,
                        companyWE: companyA,
                        companySN: companyB               
                    })
                }
            });
            return result
        },
        // 一键编排
        handleArrangeAll(){
            let params = {
                opcode: this.$code.TeamArrangeAll,
                i_serial_mark: this.pubId,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {   
                    // console.log(res)   
                    this.initData()     
                    this.$message.success(res.Message)
                }else{
                    this.$message.error(res.Message)
                }
            }).catch(err=>{}) 
        },
        // 级牌
        getPokerQuery(){
            let params = {
                opcode: this.$code.RoundCardsQuery,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {   
                    let result = res.Data.DataTable  
                    if(result.length > 0 ){
                        this.comeRule = result[0]['本轮级牌']
                    }                        
                }
            }).catch(err=>{}) 
        }, 
        switchRound(round) {
            this.currentRound = round;
            this.round = round
            if(round){
                this.initData()
            }
        },        
        startCountdown() {
            if (this.timer) {
                clearInterval(this.timer);
            }            
            this.timer = setInterval(() => {
                if (this.remainingTime > 0) {
                    this.remainingTime--;
                    this.updateCountdownDisplay();
                } else {
                    clearInterval(this.timer);
                    this.$message({
                        message: '本轮比赛时间已结束！',
                        type: 'warning'
                    });
                }
            }, 1000);
        },        
        updateCountdownDisplay() {
            const minutes = Math.floor(this.remainingTime / 60);
            const seconds = this.remainingTime % 60;
            this.countdown = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        },        
        refreshData() {
            this.$message({
                message: '数据已刷新',
                type: 'success'
            });
            this.initData()
        },
        
        printSchedule() {
            this.$message({
                message: '正在生成打印视图...',
                type: 'info'
            });
        },
        
        exportData() {
            this.$message({
                message: '数据导出成功',
                type: 'success'
            });
        },
        toggleFullScreen(){
            const routeUrl = this.$router.resolve({ name: 'teamFullArrange', query: { id: this.pubId,type: this.pubType} });
            window.open(routeUrl.href, '_blank');   
            
        }, 
        selectPoker(value){
            // console.log('=ok',value)
            this.level = value
            if(value){
                this.handleSetting(value)                
            }
        },
        handleOpen(){
            this.disabled = false
        },
        // 设置升级数，级牌
        handleSetting(value){            
            let params = {
                opcode: this.$code.RoundCards,
                i_serial_mark: this.pubId,
                i_round: this.round,
                level: value,
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    // console.log(result)
                    this.disabled = true
                }
            })
        },
         // 级牌列表
         getComeRuleList(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 26,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.comeRuleList = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                    
                }
            })
        },
        // 清除编排
        handleClearArrange(){            
            this.$confirm('确定清除本轮编排吗？').then(res=>{
                let params = {
                    opcode: this.$code.ScoreDeleteRound,
                    i_serial_mark: this.pubId,
                    i_round: 0,
                    i_games_id: 0,
                    i_desk_no: 0,
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        this.$message.success(res.Message)
                        this.errorMsg = ''  
                        this.initData()                                 
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }).catch(err=>{

            })
        },
        // 点击选择一个队伍
        slectTeam(id,name){
            this.clickCount++           
            if(this.isShowEdit){
                // console.log('可以选中')
                this.slectDeskNo  = id
                if(this.clickCount % 2){                    
                    this.teamname1 = name
                }else{
                    this.teamname2 = name
                }  
            }else{
                this.slectDeskNo = ''
            }
        },
        // 确认调整
        saveTeam(){
            if(this.teamname1 === '' ||  this.teamname2 === ''){
                this.$message.error("请选择队伍名~")
                return false
            }
            if(this.teamname1 === this.teamname2){
                this.$message.error("请选择不同的队伍名~")
                return false
            }
            let params = {
                opcode: this.$code.TeamnameExchange,
                i_serial_mark: this.pubId,
                i_round: this.round,
                Teams_Name_A: this.teamname1,
                Teams_Name_B: this.teamname2
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {  
                   this.teamname1 = ''
                   this.teamname2 = ''
                   this.isShowEdit = false
                   this.$message.error('队伍换桌成功！')
                   this.initData()           
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        editTable(){
            this.isShowEdit = !this.isShowEdit
            this.teamname1 = ''
            this.teamname2 = ''
        },
        backNext(){ 
            this.isShowEdit = !this.isShowEdit  
            this.teamname1 = ''
            this.teamname2 = ''
            this.slectDeskNo = ''
            this.initData()
        }, 
        closeShow(){
            this.isShowEdit = false
            this.slectDeskNo = ''
        },
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.title{
    font-size: 28px;
    margin-bottom: 10px;
}
.desk-table{
    width: 550px
}
.custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.custom-table >>> .el-input{
    font-size: 20px;
}
table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid #999;
    padding: 8px;
    text-align: left;
    font-size: 20px;
  }
  tr:nth-child(even) {
    background-color: #bbffbb;
  }
  thead th {
    background-color: #f2f2f2;
    font-size: 18px;
    text-align: center;
  }
  .table-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
  }
  .el-table >>> .green-row{
    background-color: #bbffbb;
    font-size: 20px;
  }
    .el-table >>> .gray-row{
    background-color: #b9b5b5;
    }
  .el-table >>> .white-row{
    background-color: #f0f9eb;
    font-size: 20px;
  }
.mg-l-20{
    margin-left: 20px;
}
.edit-btn{
    position: absolute;
    right:0
}
.edit-item{
    margin-right: 90px;
}
.tips{
    color: red;
    font-weight: bold;
    padding: 10px 0;
    margin-right: 5px;
}
.player-input{
    width: 110px;
}
.player-input >>> .el-input__inner{
    font-size: 20px
}
.save-btn{
    margin-left: 10px;
}

.round-info {
    font-size: 1.6rem;
    font-weight: bold;
}

.timer {
    font-size: 1.3rem;
    background: rgba(255, 255, 255, 0.2);
    padding: 10px 20px;
    border-radius: 20px;
    font-weight: bold;
}

.controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    flex-wrap: wrap;
}

.matches-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.match-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s, box-shadow 0.3s;
}

.match-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.table-number {
    text-align: center;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #eee;
    color: #1a6bc4;
    background-color: #f8f9fa;
    padding: 12px;
    border-radius: 8px;
    font-size: 18px;
}

.team {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    padding: 12px;
    border-radius: 8px;
}

.team-east {
    background-color: #e8f4fd;
    border-left: 5px solid #1a6bc4;
}

.team-south {
    background-color: #fff8e1;
    border-left: 5px solid #ffa000;
}

.team-position {
    font-weight: bold;
    color: #555;
    min-width: 70px;
    font-size: 16px;
}

.team-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    text-align: center;
}

.team-code {
    font-weight: bold;
    color: #1a6bc4;
    font-size: 18px;
    margin-bottom: 5px;
}

.team-name {
    font-size: 18px;
    color: #666;
}

.team-role {
    font-size: 16px;
    color: #ec0303;
    // min-width: 50px;
    text-align: right;
    background: rgba(0, 0, 0, 0.05);
    padding: 4px 8px;
    border-radius: 4px;
}

.teams-info {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

.teams-title {
    font-weight: bold;
    margin-bottom: 15px;
    color: #1a6bc4;
    border-bottom: 2px solid #eee;
    padding-bottom: 8px;
    font-size: 16px;
}

.teams-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
}

.team-item {
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    text-align: center;
    font-weight: bold;
    border-left: 4px solid #1a6bc4;
}

.round-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.action-buttons {
    display: flex;
    gap: 10px;
}
 .player-input{
    width: 110px;
}
.player-input >>> .el-input__inner{
    font-size: 20px
}
.save-btn{
    margin-left: 10px;
}
.match-card-bg{
    border: 1px solid green;
}
@media (max-width: 768px) {
    .header {
        flex-direction: column;
        text-align: center;
    }
    
    .round-info {
        margin-bottom: 15px;
    }
    
    .matches-container {
        grid-template-columns: 1fr;
    }
    
    .controls {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .round-buttons, .action-buttons {
        width: 100%;
        justify-content: center;
    }
   
}
</style>


// WEBPACK FOOTER //
// src/views/team/components/arrange.vue